import { render, staticRenderFns } from "./UploadArtworkDialog.vue?vue&type=template&id=bd75cb4a&scoped=true"
import script from "./UploadArtworkDialog.vue?vue&type=script&lang=ts"
export * from "./UploadArtworkDialog.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./UploadArtworkDialog.vue?vue&type=style&index=0&id=bd75cb4a&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "bd75cb4a",
  null
  ,true
)

export default component.exports